import { Wrapper } from "../generic/Layout"
import useTranslation from "../../hooks/useTranslation"
import BackButton from "../generic/BackButton"
import CreateButton from "./CreateButton"

const ViewTitle = ({ config }) => {
    const { t } = useTranslation()
    const listHeader = config.listHeader

    return (
        <>
            <Wrapper>
                <h2>
                    {config?.layout?.showBackButton && <BackButton config={{}} />}
                    {t(listHeader.text)}
                </h2>
                <CreateButton listHeader={listHeader} entity={config.entity} />
            </Wrapper>
        </>
    )
}

export default ViewTitle
